import { BreadCrumbSign } from "../../components/generic/breadcrumbSign.component";
import { EditSuperAdmin } from "../../components/superAdmin/EditSuperAdmin.component";
export const SuperAdminEditPage = () => {
  return (
    <div className="row gx-0">
      <div className="col-12 m-2">
        <div className="d-flex flex-column px-1 me-3">
          <p className="content-header ms-1">
            Super Admin <BreadCrumbSign /> Update
          </p>
          <EditSuperAdmin />
        </div>
      </div>
    </div>
  );
};
